import React, { useState } from 'react';
import '../styles/Gallery.css'; // Importer le CSS global
import Modal from '../components/Modal';  // Importer le composant Modal

const Salonasso = () => {  // Renommer 'salonasso' en 'Salonasso'
  const images = [
    'salon1.jpg',
    'salon2.jpg',
    'salon3.jpg',
    // Ajoute ici toutes les autres images
  ];

  const [modalImage, setModalImage] = useState(null);  // État pour l'image du modal
  const [modalAltText, setModalAltText] = useState("");  // État pour le texte alternatif de l'image

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  return (
    <div className="album-detail">
      <h1>Album forum des associations</h1>
      <div className="image-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={`/album/salonasso/${image}`}
            alt={`Détail de l'image ${index + 1}`}  // Descriptions concises pour l'accessibilité
            className="album-image"
            onClick={() => openModal(`/album/salonasso/${image}`, `Détail de l'image ${index + 1}`)}  // Ouvre en grand
          />
        ))}
      </div>

      {/* Affichage du Modal lorsque l'image est cliquée */}
      {modalImage && <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />}
    </div>
  );
};

export default Salonasso;  // Pas de changement ici
